/* eslint-disable import/prefer-default-export */

export const ARTIST_OWNERSHIPS_CHANGED = 'ARTIST_OWNERSHIPS_CHANGED';